// extracted by mini-css-extract-plugin
export default {"title":"ThirdScreen_title__LFW4K","description":"ThirdScreen_description__okVz5","row":"ThirdScreen_row__350f0"};